export default {
  'app.member': 'Permisos de miembros',
  'app.member.management': 'Gestión de miembros',
  'app.member.management.search': 'Filtros de búsqueda',
  'app.member.management.invite': 'Invitar a miembros del equipo',
  'app.member.management.invite.sso.tip':
    'La organización ha habilitado el inicio de sesión SSO, y los miembros que no han recibido roles se asignarán automáticamente el rol por defecto. Puede modificar sus roles después de que se unan.',
  'app.member.management.invite.edit': 'Editar miembros',
  'app.member.management.invite.name.first': 'Nombre',
  'app.member.management.invite.name.first.placeholder': `Introduzca el nombre del invitado`,
  'app.member.management.invite.name.first.validate': `Introduzca el apellido del invitado`,
  'app.member.management.invite.name.last': 'Apellido',
  'app.member.management.invite.name.last.placeholder': `Introduzca el apellido del invitado`,
  'app.member.management.invite.name.last.validate': `Introduzca el apellido del invitado`,
  'app.member.management.invite.email': 'Invitar a miembros por correo electrónico',
  'app.member.management.invite.email.placeholder': `Introduzca el correo electrónico, presione Enter para añadir`,
  'app.member.management.invite.email.validate.empty': `Introduzca el correo electrónico del invitado`,
  'app.member.management.invite.email.validate.right': 'Introduzca un correo electrónico válido',
  'app.member.management.invite.ssoConfig': 'Servicio SSO de la organización',
  'app.member.management.invite.ssoConfig.placeholder':
    'Seleccione el servicio SSO de la organización',
  'app.member.management.invite.ssoConfig.validate':
    'Seleccione un servicio SSO de la organización',
  'app.member.management.invite.role': 'Rol',
  'app.member.management.invite.role.placeholder':
    'Seleccione una función en la organización para enviar invitación',
  'app.member.management.invite.role.empty': 'Sin rol',
  'app.member.management.invite.role.create': 'Añadir una función',
  'app.member.management.invite.role.validate':
    'Seleccione una función en la organización para enviar invitación',
  'app.member.management.invite.ok': 'Confirmar',
  'app.member.management.invite.cancel': 'Cancelar',
  'app.member.management.table.name': 'Nombre de la cuenta',
  'app.member.management.table.id': 'ID de cuenta',
  'app.member.management.table.status': 'Estado de la cuenta',
  'app.member.management.table.status.enable': 'Activar',
  'app.member.management.table.status.disable': 'Desactivar',
  'app.member.management.table.status.wait': 'Pendiente de unión',
  'app.member.management.table.time.last': 'Hora de la última visita',
  'app.member.management.table.time.create': 'Tiempo de creación',
  'app.member.management.table.operation': 'Operación',
  'app.member.management.table.operation.detail': 'Detalles',
  'app.member.management.table.operation.edit': 'Editar',
  'app.member.management.table.operation.resend': 'Reenviar',
  'app.member.management.table.operation.disable': 'Desactivar',
  'app.member.management.table.operation.enable': 'Activar',
  'app.member.management.table.operation.delete': 'Eliminar la cuenta',
  'app.member.management.table.operation.delete.confirm':
    'La cuenta será eliminada permanentemente',
  'app.member.management.table.operation.delete.confirm.ok': 'Confirmar',
  'app.member.management.table.operation.delete.confirm.cancel': 'Cancelar',
  'app.member.management.table.operation.invite.success': 'Invitación exitosa',
  'app.member.role': 'Gestión de roles',
  'app.member.role.create': 'Crear un rol',
  'app.member.role.edit': 'Editar un rol',
  'app.member.role.create.placeholder': `Introduzca el nombre del rol`,
  'app.member.role.admin': 'Administrador',
  'app.member.role.rights': 'Derechos',
  'app.member.role.members': 'Miembros',
  'app.member.role.name.placeholder': 'Introduzca el nombre del rol',
  'app.member.role.creater': 'Creado por',
  'app.member.role.creater.validate': 'Introduczca un nombre de rol (Este nombre ya está en uso)',
  'app.member.role.console': 'Consola',
  'app.member.role.empty': 'Vacío',
  'app.member.role.tip':
    'Los roles globales son roles preestablecidos de cada proyecto por defecto',
  'app.member.role.submit': '¡Listo!',
  'app.member.role.save': '¡Guardado con éxito!',
  'app.member.role.delete':
    'Al eliminar este rol, los permisos asociados a sus miembros se desactivarán.',
  'app.member.role.delete.ok': 'Eliminar',
  'app.member.role.delete.cancel': 'Cancelar',
  'app.member.role.members.table.search': 'Filtros de búsqueda',
  'app.member.role.members.table.name': 'Nombre de la cuenta',
  'app.member.role.members.table.id': 'ID de cuenta',
  'app.member.role.mCorreo electrónicoembers.table.emial': 'Correo electrónico',
  'app.member.role.members.table.status': 'Estado de la cuenta',
  'app.member.role.members.table.status.enable': 'Activar',
  'app.member.role.members.table.status.disable': 'Desactivar',
  'app.member.role.members.table.status.wait': 'Pendiente de unión',
  'app.member.role.members.table.time.last': 'Hora de la última visita',
  'app.member.role.members.table.time.create': 'Tiempo de creación',
  'app.member.role.members.table.operation': 'Operaciones',
  'app.member.role.members.table.operation.detail': 'Detalles',
  'app.member.role.members.table.operation.detail.title': 'Detalles de miembro',
  'app.member.role.members.table.operation.detail.permission': 'Detalles del permiso',
  'app.member.role.members.table.operation.delete': 'Eliminar rol',
  'app.member.role.permission.sharing': 'Todas las aplicaciones comparten permisos',
  'app.member.role.permission.sharing.tip':
    'Tras comprobarlo y guardarlo, los permisos que posee este rol se mantienen en todas las aplicaciones.',
  'app.member.management.create.org': 'Permitir a los miembros crear organizaciones',
  'app.member.management.create.yes': 'Sí',
  'app.member.management.create.no': 'No',
  'app.member.roleCopy.copy': 'Copiar roles',
  'app.member.roleCopy.title': 'Copiar roles a otras organizaciones',
  'app.member.roleCopy.select': 'Seleccionar organización',
  'app.member.roleCopy.selectTip': 'Seleccione una organización',
  'app.member.roleCopy.all': 'Seleccionar todo',
  'app.member.roleCopy.success': '¡Copiado con éxito!',
  'app.member.role.otp.target.tip': `<p>1) Cuando el objetivo es un número de teléfono:</p>
    <p>Si el operador no tiene permiso para ver el objetivo, el número mostrado en el registro histórico será una versión ofuscada. Cuando el número está ofuscado, sólo se muestran los 3 primeros dígitos y los 2 últimos dígitos.</p>
    <p>2) Cuando el objetivo es una dirección de correo electrónico:</p>
    <p>Se muestran los 2 dígitos y la dirección de correo electrónico no se modifica a partir de "{'@'}".</p>
    <p>Por ejemplo:</p>
    <p>otpsupport{'@'}engagelab.com</p>
    <p>Tras la ofuscación, aparece como:</p>
    <p>ot***{'@'}engagelab.com</p>
    `,
};
